<template>
  <lx-dialog
    v-model="showBlacklistDialog"
    @keydown.esc="close"
    overlay
    :size="{x: '90', y: '70'}"
  >

    <template #header>
      <div class="text-h6 font-weight-light pa-3 layout-row layout-align-center-center grey--text" :class="[isDarkMode ? 'text--lighten-4' : 'text--darken-2']">
        <strong>{{ $t('BLACKLIST.DIALOG.HEADER') }}</strong>
      </div>
    </template>

    <template #default>
      <div v-bind:style="{'z-index': '4'}" class="layout-row layout-align-center-center pa-1">
        <div class="flex layout-row mx-1">
          <lx-search-field
            :placeholder="$t('BLACKLIST.DIALOG.SEARCH_PLACEHOLDER')"
            dense
            v-model="tableObj.filterValue"
            :data-method="getDataForTable"
          ></lx-search-field>
        </div>
      </div>

      <v-divider v-bind:style="{'border-color':compColor.lightDivider}"></v-divider>

      <div class="flex layout-column pa-1" style="overflow-y: hidden;">
        <div class="elevation-3 flex layout-column pa-1" style="border-radius: 6px;" :style="{'background': compColor.lxExpansion.background}">
          <div style="border-radius: 6px;border: 1px solid rgba(0,0,0,0.1);" class="flex layout-column" ref="BlackListDialog">
            <lx-data-table
              v-model="tableObj.selection"
              tableName="BlackListDialog"
              :items="patients"
              :headers="tableObj.headers"
              :loading="tableObj.loading"
              :preventRowClick="true"
              :hideContextFilter="true"
              :tableOptions="tableObj.options"
              :setResize=true>

              <template #cellrenderer="{ value }">
                <div v-if="value.f.renderer === 'blacklist'" style="height:35px;cursor:pointer;" class="layout-column layout-align-center-start">
                  <div @click="openContextOnRowClick($event, value.i)" class="layout-row layout-align-center-center">
                    <v-icon class="mr-1" :color="compColor.primeColor" style="font-size: 17px;">mdi-account-off</v-icon>
                    <label style="cursor: pointer;">{{ $t('BLACKLIST.TABLE.BLACKLIST_PATIENT') }}</label>
                  </div>
                </div>
              </template>
            </lx-data-table>
          </div>
        </div>
      </div>

      <v-divider v-bind:style="{'border-color':compColor.lightDivider}"></v-divider>

      <div class="layout-row pa-0">
        <lx-pagination :page-name="'BlackListDialog'"
                       :page-options="pagingOptions"
                       :page-change="getDataForTable">
        </lx-pagination>
      </div>
    </template>

    <template #actions>
      <div class="layout-row pa-1">
        <v-btn depressed :color="compColor.primeColor" :dark="isDarkMode" class="flex white--text text-none" @click="close">
          {{ $t('buttons.close.value') }}
        </v-btn>
      </div>
    </template>

  </lx-dialog>
</template>

<script>
import formsMetaData from '../../components/documentation/shared/formsMetaData'
import utils from '../../common/utils'

export default {
  name: 'BlacklistDialog',
  mixins: [formsMetaData, utils],
  props: {
    showBlacklistDialog: Boolean
  },
  data () {
    return {
      tableObj: {
        loading: false, // benutzt, während des GetData, um eine Ladeanimation einzublenden
        options: {
          sortBy: ['lastname'],
          sortDesc: [false],
          getClassForItem: (row) => {
            if (row.isExpanded) {
              return 'row-bold'
            }
            return ''
          }
        },
        filterValue: null,
        headers: [
          {
            text: 'Nachname',
            value: 'lastname',
            width: '200px',
            sortable: true
          },
          {
            text: 'Vorname',
            value: 'firstname',
            width: '200px',
            class: 'pinned',
            sortable: true
          },
          {
            text: 'AIS ID',
            value: 'ais_id',
            width: '150px',
            class: 'pinned',
            sortable: true
          },
          {
            text: 'Geschlecht',
            value: 'gender',
            width: '100px',
            class: 'text-center',
            renderer: 'gender'
          },
          {
            text: 'Geburtsdatum',
            value: 'birthday',
            width: '150px',
            renderer: 'date',
            sortable: true
          },
          {
            text: '',
            value: '',
            renderer: 'blacklist'
          }
        ]
      },
      pagingOptions: {
        limit: 25,
        skip: 0,
        count: 0
      },
      patients: [],
      isLoading: false,
      durationList: []
    }
  },
  mounted () {
    this.durationList = this.formsMetaData.blackListDurationList

    if (typeof this.createCategory === "function" && typeof this.addEntryToMenu === "function") {
      this.createCategory('BlackListDialog')
    }
  },
  methods: {
    /**
     * Get all patients without ignored flag
     */
    getDataForTable (options) {
      if (this.tableObj.loading) return
      this.tableObj.loading = true

      if (options && typeof options.skip === 'number') {
        this.pagingOptions.skip = options.skip
      }
      if (options && options.limit) {
        this.pagingOptions.limit = options.limit
      }

      let opts = {
        skip: this.pagingOptions.skip,
        limit: this.pagingOptions.limit
      }

      if (this.tableObj.options && this.tableObj.options.sortBy && this.tableObj.options.sortBy.length > 0) {
        opts.sort = {}
        opts.sort[this.tableObj.options.sortBy[0]] = this.tableObj.options.sortDesc[0] ? -1 : 1
      }

      let query = {}

      if (this.tableObj.filterValue) {
        query.search = this.tableObj.filterValue
      }

      this.$http.get('/patients/blacklist/whitelisted?config={"opts":' + JSON.stringify(opts) + ', "query": ' + JSON.stringify(query) + '}')
        .then(res => {
          if (res.data) {
            this.patients = res.data.items || []
            this.pagingOptions.count = res.data.count || 0
          }
        })
        .catch(this.NotifyError)
        .finally(() => {
          this.tableObj.loading = false
        })
    },

    initView () {
      this.patients = []
      this.tableObj.filterValue = ''
      this.pagingOptions = {
        limit: 25,
        skip: 0,
        count: 0
      }
    },

    /**
     * Open special context menu for selected patient
     *
     * @param event The opening event
     * @param item The patient value
     */
    openContextOnRowClick (event, item) {
      if (item) {
        const self = this
        let contextValue = []

        // iterate trough duration list to create entries for context menu
        this.durationList.forEach(itemValue => {
          contextValue.push({
            title: itemValue.text,
            action: function (event) {
              self.blacklistPatient(event, itemValue.key)
            }
          })
        })

        this.addEntryToMenu({
          type: 'BlackListDialog',
          value: contextValue
        })

        this.$lxContext.open(event, 'BlackListDialog', item)
      }
    },

    /**
     * Trigger method to add patient to blacklist
     */
    blacklistPatient (patient, selection) {
      // get object with date and type of ignoring in dependency to selected item form context menu
      const params = this.returningDateForBlackList(selection)

      if (params && params.type && patient && patient._id) {
        if (this.tableObj.loading || this.isLoadingData) return
        this.isLoadingData = true

        this.$http.put('/patients/blacklist', {id: patient._id, type: params.type, date: params.date})
          .then(() => {
            this.isLoadingData = false

            this.getDataForTable()
            this.NotifySystem(this.$t('BLACKLIST.NOTIFICATIONS.BLACKLIST_SUCCESS'))
          })
          .catch(() => {
            this.NotifyError(this.$t('BLACKLIST.NOTIFICATIONS.BLACKLIST_ERROR'))
          })
          .finally(() => {
            this.isLoadingData = false
          })
      }
    },

    /**
     * Close modal of black-list dialog
     */
    close () {
      this.$emit('set-show-blacklist-dialog')
    }
  },
  watch: {
    'showBlacklistDialog' (newValue) {
      if (newValue) {
        this.initView()
      }
    }
  }
}
</script>

<style lang="scss">
#ContextMenuRef {
  z-index: 1000 !important;
}
</style>
